const breadcrumbsHome = { name: 'Home', pathName: '/' }
const breadcrumbsConciliateCoupons = { name: 'Conciliar Cupons', pathName: '/conciliate-coupons' }

export default [
  {
    path: '/conciliate-coupons',
    pathName: 'conciliate-coupons',
    component: () => import('@/modules/coupons/conciliate-coupons/views/pages/ConciliateCoupons.vue'),
    meta: {
      title: 'Conciliar Cupons',
      breadcrumbs: [breadcrumbsHome, breadcrumbsConciliateCoupons]
    }
  }
]
